"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripAddonId = exports.AddonId = exports.CouponId = exports.ReviewId = exports.PaymentId = exports.ReservationId = exports.InventoryId = exports.TripVersionId = exports.TripId = exports.SupplierId = exports.HostId = exports.AccountId = void 0;
var AccountId = function (value) { return value; };
exports.AccountId = AccountId;
var HostId = function (value) { return value; };
exports.HostId = HostId;
var SupplierId = function (value) { return value; };
exports.SupplierId = SupplierId;
var TripId = function (value) { return value; };
exports.TripId = TripId;
var TripVersionId = function (value) { return value; };
exports.TripVersionId = TripVersionId;
var InventoryId = function (value) { return value; };
exports.InventoryId = InventoryId;
var ReservationId = function (value) { return value; };
exports.ReservationId = ReservationId;
var PaymentId = function (value) { return value; };
exports.PaymentId = PaymentId;
var ReviewId = function (value) { return value; };
exports.ReviewId = ReviewId;
var CouponId = function (value) { return value; };
exports.CouponId = CouponId;
var AddonId = function (value) { return value; };
exports.AddonId = AddonId;
var TripAddonId = function (value) { return value; };
exports.TripAddonId = TripAddonId;
//# sourceMappingURL=EntityIdTypes.js.map